import { useSidebar } from '@ibsys/kit';

/**
 * Содержимое панели «Диалог» показано: панель развёрнута либо не сворачивается вовсе.
 *
 * @param isCollapsible - панель сворачивается переключателем боковой панели ({@link DialogPanelToggle})
 */
export const useIsDialogPanelShown = (isCollapsible: boolean): boolean => {
  const { open } = useSidebar();
  return open || !isCollapsible;
};
